<template>
  <div class="form-group">
    <label class="form-label">Letzte Nachricht</label>
    <el-date-picker
      type="daterange"
      range-separator="bis"
      start-placeholder="Start"
      end-placeholder="Ende"
      value-format="yyyy-MM-dd"
      format="dd.MM.yyyy"
      @input="
        $parent.$emit('filter-update', {
          value: $event ? $event.join('+') : null,
          name
        })
      "
      v-model="value"
    >
    </el-date-picker>
  </div>
</template>

<script>
import { DatePicker } from "element-ui";

export default {
  components: {
    [DatePicker.name]: DatePicker
  },
  data() {
    return {
      value: null
    };
  },
  props: {
    name: {
      type: String,
      required: true
    }
  }
};
</script>
